"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopupManager = void 0;
var react_1 = require("react");
var PopupContext_1 = require("./PopupContext");
function usePopupManager() {
    var popupManager = react_1.useContext(PopupContext_1.PopupContext).popupManager;
    var open = popupManager.open, closeAll = popupManager.closeAll;
    return {
        open: open,
        closeAll: closeAll,
    };
}
exports.usePopupManager = usePopupManager;
//# sourceMappingURL=usePopupManager.js.map